import type { LpEvent } from 'src/types/lp-events';

// Matches cn-events-lp's login-hero and auth/preview-shared palettes.
// Keep this separate from the CMS theme: these colors are saved in LP events.
export const LP_EVENT_PALETTE = {
  primary: '#283C75',
  accent: '#B5DCF0',
  onPrimary: '#FFFFFF',
} as const;

export const LP_EVENT_DEFAULT_COLORS = {
  mainBanners: {
    bgColor: LP_EVENT_PALETTE.primary,
    textColor: LP_EVENT_PALETTE.onPrimary,
    buttonColor: LP_EVENT_PALETTE.accent,
    buttonTextColor: LP_EVENT_PALETTE.primary,
  },
  // This color is also used for text/icons on white surfaces in the LP.
  primaryButtons: {
    bgColor: LP_EVENT_PALETTE.primary,
    textColor: LP_EVENT_PALETTE.onPrimary,
  },
  homePage: {
    bannerText: {
      specialColor: LP_EVENT_PALETTE.accent,
    },
  },
} as const;

type CustomContent = LpEvent['customContent'];

export function resolveLpEventContentColors(
  content: CustomContent,
  mode: 'create' | 'edit'
): CustomContent {
  // Editing must preserve even incomplete legacy palettes exactly as received.
  if (mode === 'edit') return content;

  return {
    ...content,
    mainBanners: { ...content.mainBanners, ...LP_EVENT_DEFAULT_COLORS.mainBanners },
    primaryButtons: { ...content.primaryButtons, ...LP_EVENT_DEFAULT_COLORS.primaryButtons },
    homePage: {
      ...content.homePage,
      bannerText: {
        ...content.homePage?.bannerText,
        ...LP_EVENT_DEFAULT_COLORS.homePage.bannerText,
      },
    },
  };
}
